import { DefaultApi } from './api'
import {
  ConfirmPlateData,
  ConfirmPlateResponse,
  CreateData,
  DataCpfRegistered,
  DataPasswordRecovery,
  DataRegistered,
  DataSMSCode,
  DataWhatsappCode,
  Issues,
  LoginData,
  Register,
} from './interfaces'

export const login = (data: LoginData) =>
  DefaultApi.request('/auth/login', { method: 'POST', data, withCredentials: true })

export const register = (data: Register) =>
  DefaultApi.request<DataRegistered>('/auth/signup', {
    method: 'POST',
    data,
    withCredentials: true,
  })

export const cpfRegistered = (
  cpf: string,
  reCaptchaToken: string,
): Promise<DataCpfRegistered> =>
  DefaultApi.request<DataCpfRegistered>('/auth/exists', {
    method: 'GET',
    params: { cpf },
    headers: { 'reCaptcha-token': reCaptchaToken },
  })

export const sendResetPasswordCode = (
  cpf: string,
  phoneId: string,
  method: 'sms' | 'whatsapp',
  reCaptchaToken: string,
) =>
  DefaultApi.request<DataSMSCode>('/password-recovery/send-code', {
    method: 'post',
    data: { cpf, phone_id: phoneId, method },
    headers: { 'reCaptcha-token': reCaptchaToken },
  })

export const passwordRecovery = (cpf: string, recaptchaToken: string) =>
  DefaultApi.request<DataPasswordRecovery>('/password-recovery/phones', {
    method: 'GET',
    params: { cpf },
    headers: { 'reCaptcha-token': recaptchaToken },
  })

export const verifyResetPasswordCode = (
  cpf: string,
  phoneId: string,
  code: string,
  method: 'sms' | 'whatsapp',
  reCaptchaToken: string,
) =>
  DefaultApi.request<DataSMSCode>('/password-recovery/confirm-code/sms', {
    method: 'post',
    data: { cpf, phone_id: phoneId, method, code },
    headers: { 'reCaptcha-token': reCaptchaToken },
  })

export const verifyResetPasswordCodeWhatsapp = (
  userUuid: string,
  passwordRecoveryUuid: string,
) =>
  DefaultApi.request<DataWhatsappCode>('/password-recovery/confirm-code/whatsapp', {
    method: 'post',
    data: { user_uuid: userUuid, password_recovery_uuid: passwordRecoveryUuid },
  })

export const changePassword = (
  password: string,
  confirmation_token: string,
  cpf: string,
  reCaptchaToken: string,
) =>
  DefaultApi.request('/password-recovery/change-password', {
    method: 'POST',
    data: { cpf, password, confirmation_token },
    headers: { 'reCaptcha-token': reCaptchaToken },
  })

export const confirmPlate = (data: ConfirmPlateData) =>
  DefaultApi.request<ConfirmPlateResponse>('/confirm-plate', {
    method: 'POST',
    data,
  })

export const create = (data: CreateData) =>
  DefaultApi.request('/migration/user', { method: 'POST', data, withCredentials: true })

export const logout = () =>
  DefaultApi.request('/auth/logout', {
    method: 'GET',
    withCredentials: true,
  })

export const issues = () =>
  DefaultApi.request<Issues>('/user/issues', {
    method: 'GET',
    withCredentials: true,
  })
